export default {
  title: 'Punkte sammeln & Belohnungen erhalten',
  header: {
    pickup: 'Abholung in 5 Minuten',
  },
  recommendations: {
    title: 'Empfohlen',
  },
  discounts: {
    title: 'Rabatte',
    data: [
      {
        title: '+125 Extra Punkte',
        description: 'Bewerten Sie uns auf Google',
      },
      {
        title: '+{{amount}} Rabatt',
        description: '+{{amount}} Rabatt, wenn Sie mit dem Code {{code}} bezahlen',
      },
    ],
    button: {
      add: '+ Hinzufügen',
    },
  },
  rewards: {
    title: 'Prämien & Coupons',
    balance: 'Kontostand',
    points: 'Punkte',
  },
};
